import React, { FC } from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { WEBSITE_TITLE, SITE_URL } from '../../app-config.json';

export type MetaTagType = React.DetailedHTMLProps<React.MetaHTMLAttributes<HTMLMetaElement>, HTMLMetaElement>[] | undefined
export type LinkTagType = React.DetailedHTMLProps<React.LinkHTMLAttributes<HTMLLinkElement>, HTMLLinkElement>[] | undefined

const noIndexedTag = {
  name: 'robots',
  content: 'noindex, nofollow',
}

export interface Props {
  propMetaDescription?: string,
  lang?: string,
  meta?: MetaTagType
  link?: LinkTagType
  title?: string,
  indexing?: boolean
}

const SEO: FC<Props> = ({ propMetaDescription, lang = 'en', meta = [], link = [], title, indexing = true }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = propMetaDescription || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title || site.siteMetadata.title}

      link={[
        { rel: 'icon', href: require('../assets/logo-gold.png') },
        ...link
      ]}

      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title || site.siteMetadata.title,
        },
        {
          property: `og:site_name`,
          content: WEBSITE_TITLE,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: "og:image", itemProp: "image",
          content: `${SITE_URL}${require('../assets/logo-gold.png')}`
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title || site.siteMetadata.title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },

        indexing ? {} : { ...noIndexedTag }, //if indexing true pass empty obj else pass noindexing tag obj

        ...meta
      ]}
    />
  )
}

export default SEO
